import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";
import { NAV_LINKS, PROFESSIONAL, WHATSAPP_DISPLAY, waLink, INSTAGRAM_URL } from "@/data/site";

const Footer = () => (
  <footer data-testid="site-footer" className="bg-raiz-950 text-raiz-100">
    <div className="container-x grid gap-12 py-16 lg:grid-cols-12 lg:py-20">
      <div className="lg:col-span-5">
        <div className="flex items-center gap-3">
          <img src="/assets/tree-mark-white.png" alt="" className="h-10 w-auto" width="40" height="40" />
          <span className="leading-tight">
            <span className="block font-serif text-xl text-paper">{PROFESSIONAL.name}</span>
            <span className="mt-1 block text-[10px] uppercase tracking-[0.24em] text-gold-300">Psicóloga • Neuropsicóloga</span>
          </span>
        </div>
        <p className="mt-6 max-w-sm text-sm leading-relaxed text-raiz-100/70">
          Psicologia Clínica e Neuropsicologia para crianças, adolescentes e adultos — atendimento presencial e online.
        </p>
        <p className="mt-6 text-sm leading-relaxed text-raiz-100/90" data-testid="footer-professional-id">
          {PROFESSIONAL.fullName}
          <br />
          {PROFESSIONAL.titles}
          <br />
          {PROFESSIONAL.crp}
        </p>
      </div>
      <div className="lg:col-span-3">
        <p className="text-xs uppercase tracking-[0.28em] text-raiz-300">Navegação</p>
        <ul className="mt-5 space-y-3">
          {NAV_LINKS.map((l) => (
            <li key={l.to}>
              <Link to={l.to} data-testid={`footer-${l.testId}`} className="text-sm text-raiz-100/75 transition-colors hover:text-paper">
                {l.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <div className="lg:col-span-4">
        <p className="text-xs uppercase tracking-[0.28em] text-raiz-300">Contato</p>
        <a
          href={waLink()}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-whatsapp-link"
          className="mt-5 inline-block text-sm text-paper underline decoration-raiz-300/50 underline-offset-4 transition-colors hover:decoration-paper"
        >
          WhatsApp {WHATSAPP_DISPLAY}
        </a>
        <a
          href={INSTAGRAM_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-instagram-link"
          className="mt-4 flex w-fit items-center gap-2 text-sm text-raiz-100/75 transition-colors hover:text-paper"
        >
          <Instagram aria-hidden="true" className="h-4 w-4" />
          @sabrinamota.psi
        </a>
        <p className="mt-5 text-sm leading-relaxed text-raiz-100/70">
          Atendimento presencial em Taboão da Serra — SP (Metropolitan Office, Estr. São Francisco, 2008 — ao lado do Shopping Taboão) e online por videochamada, conforme as normas profissionais vigentes.
        </p>
      </div>
    </div>
    <div className="border-t border-paper/10">
      <div className="container-x flex flex-col gap-3 py-6 text-xs text-raiz-100/50 sm:flex-row sm:items-center sm:justify-between">
        <p>© {new Date().getFullYear()} {PROFESSIONAL.brand}. Conteúdo em conformidade com o Código de Ética Profissional do Psicólogo e as resoluções do CFP.</p>
        <Link to="/privacidade" data-testid="footer-privacidade-link" className="underline underline-offset-4 transition-colors hover:text-paper">
          Política de Privacidade
        </Link>
      </div>
    </div>
  </footer>
);

export default Footer;
